<ng-http-loader [debounceDelay]="600" spinner="sk-three-bounce" [filteredHeaders] = "['hide-ng-http-loader']"></ng-http-loader>
<app-header (snackBarEvent)="onSnackBar()"></app-header>
<div class="container">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>